export default __webpack_public_path__ + "/dist/images/italy-flag.3d95bc2c56fa01416e31223bd42ebbfe.svg";